import { render, staticRenderFns } from "./QuotationEdit.vue?vue&type=template&id=20591c56&scoped=true&"
import script from "./QuotationEdit.vue?vue&type=script&lang=js&"
export * from "./QuotationEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20591c56",
  null
  
)

export default component.exports